/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function normalizeTargetingSearchPage(page: any, options?: {
  pageSize?: number;
  currentPage?: number;
  mapItem?: (item: any) => any;
}): any {
  const normalizedPage = page || {};
  const rawSearchResults = _.isArray(normalizedPage.searchResults) ? normalizedPage.searchResults : [];
  const rawResults = rawSearchResults.length > 0 ? rawSearchResults :
    (_.isArray(normalizedPage.results) ? normalizedPage.results : []);
  const mapItem = options && options.mapItem;
  normalizedPage.searchResults = mapItem ? _.map(rawResults, mapItem) : rawResults;

  const pageSize = normalizedPage.pageSize || (options && options.pageSize) || normalizedPage.searchResults.length || 0;
  const currentPage = (options && options.currentPage) || 1;
  const pageIndex = _.isFinite(normalizedPage.page) ? normalizedPage.page : Math.max(currentPage - 1, 0);
  const totalHits = _.isFinite(normalizedPage.totalHits) ? normalizedPage.totalHits :
    (_.isFinite(normalizedPage.totalCount) ? normalizedPage.totalCount : normalizedPage.searchResults.length);
  const pageStart = _.isFinite(normalizedPage.pageStart) ? normalizedPage.pageStart :
    (totalHits > 0 ? (pageIndex * pageSize) + 1 : 0);
  const pageEnd = _.isFinite(normalizedPage.pageEnd) ? normalizedPage.pageEnd :
    (totalHits > 0 ? Math.min(totalHits, (pageIndex * pageSize) + normalizedPage.searchResults.length) : 0);

  normalizedPage.pageSize = pageSize;
  normalizedPage.totalHits = totalHits;
  normalizedPage.pageStart = pageStart;
  normalizedPage.pageEnd = pageEnd;
  return normalizedPage;
}
